import React, { useState, useEffect } from 'react'
import { FaUser, FaInfoCircle, FaSave } from 'react-icons/fa';
import { Spin, notification, DatePicker } from 'antd'
import dayjs from 'dayjs';
import moment from 'moment';
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';
export default function CpnDongHD({ loanId }) {
  const [closeDate, setCloseDate] = useState('01/01/1999');
  const [amount, setAmount] = useState('0');
  const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row
  // const handleInputChange = (event) => {
  //   const value = event.target.value;

  //   // Kiểm tra nếu giá trị chỉ chứa số nguyên (có thể là rỗng)
  //   if (/^\d*$/.test(value)) {
  //     setAmount(value); // Cập nhật state nếu là số nguyên
  //   }

  //   setTotalMoneyNeedClose(totalInterest + totalMoney + debitMoney + Number(value))
  // };

  const handleInputChange = (event) => {
    const value = event.target.value;

    // Kiểm tra nếu giá trị chỉ chứa số nguyên, có thể là rỗng hoặc số âm
    if (/^-?\d*$/.test(value)) {
      setAmount(value); // Cập nhật state nếu là số nguyên hoặc số âm
    }

    setTotalMoneyNeedClose(totalInterest + totalMoney + debitMoney + Number(value));
};

  const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;

  useEffect(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Lấy ngày và thêm số 0 nếu cần
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Lấy tháng (0-11) và thêm số 0
    const year = today.getFullYear(); // Lấy năm

    const formattedDate = `${day}/${month}/${year}`;
    setCloseDate(formattedDate); // Lưu vào state
  }, []); // Chỉ chạy một lần khi component được mount

  const [name, setName] = useState('');
  const [totalMoney, setTotalMoney] = useState('');
  const [rate, setRate] = useState('');
  const [fromDate, setFromDate] = useState('01/01/1999');
  const [totalInterest, setTotalInterest] = useState(0);
  const [debitMoney, setDebitMoney] = useState('');
  const [status, setStatus] = useState('');
  const [lastDateOfPay, setLastDateOfPay] = useState('01/01/1999')
  const [moneyPerPay, setMoneyPerPay] = useState(0);
  const [totalMoneyNeedClose, setTotalMoneyNeedClose] = useState(0)
  const [sumInterest, setSumInterest] = useState(0);
  
  const [dayDiff, setDayDiff] = useState(0);
  useEffect(() => {
    const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
    fetch(`${process.env.REACT_APP_API_DB_URL}/loan-credit/${loanId}`,
      {
        method: 'GET', // Hoặc 'POST' nếu cần thiết
        headers: {
          'Authorization': `Bearer ${token}`, // Thêm token vào headers
          'Content-Type': 'application/json' // Nếu cần
        }
      })
      .then(response => response.json())
      .then(data => {
        setName(data.NAME)
        setTotalMoney(data.TOTAL_MONEY);
        setRate(data.RATE);
        const formattedDate = moment(data.FROM_DATE).format('DD-MM-YYYY');
        setFromDate(formattedDate);
        setDebitMoney(data.DEBIT_MONEY);
        setStatus(data.STR_STATUS);
        setLastDateOfPay(moment(data.LAST_DATE_OF_PAY).format('DD/MM/YYYY'));
        setMoneyPerPay(data.MONEY_NEED_PER_PAY);
        // console.log(data.LAST_DATE_OF_PAY)
      })
      .catch(error => console.error('Error fetching data:', error))
  }, []);

  // const calInterest = () => {
  //   const today = new Date();

  // }

  function parseDate(dateString) {
    const parts = dateString.split('/'); // Tách chuỗi theo dấu '/'
    const day = parseInt(parts[0], 10); // Ngày
    const month = parseInt(parts[1], 10) - 1; // Tháng (0-11)
    const year = parseInt(parts[2], 10); // Năm

    return new Date(year, month, day); // Tạo đối tượng Date
  }

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0'); // Lấy ngày và đảm bảo có 2 chữ số
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Lấy tháng (tháng bắt đầu từ 0, nên cộng thêm 1)
    const year = date.getFullYear(); // Lấy năm

    return `${day}/${month}/${year}`; // Trả về chuỗi theo định dạng DD/MM/YYYY
  }

  useEffect(() => {
    if (closeDate) {
    //  console.log(`${lastDateOfPay}: ${typeof lastDateOfPay} ${closeDate}: ${typeof closeDate}`)
      const startDate = moment(lastDateOfPay, "DD/MM/YYYY");
      const endDate = moment(closeDate, "DD/MM/YYYY");

      const daysDifference = endDate.diff(startDate, 'days');

    //  console.log(`Số ngày giữa hai ngày: ${daysDifference} ngày`);
      let sumInterest_ = Number(moneyPerPay) * daysDifference

      console.log(`gốc: ${moneyPerPay}, số ngày: ${daysDifference} tổng lãi: ${sumInterest}, `)

      setTotalInterest(sumInterest);
      setTotalMoneyNeedClose(sumInterest + totalMoney + debitMoney + Number(amount))
      setDayDiff(daysDifference);
      setSumInterest(sumInterest_);
    }
  }, [closeDate, fromDate, dayDiff]); // Gọi API khi closeDate hoặc fromDate thay đổi


  const showNotification = (message, type) => {
    notification[type]({
      description: message,
      placement: 'topRight', // Notification position
    });
  };

  const handleSubmit = async () => {
    // sumInterest + totalMoney + debitMoney + Number(amount)
    const payload = {
        amount      : Number(amount),
        dayDiff      :   Number(dayDiff),
    };
    try {
      setLoadingItem(true);
      const token = localStorage.getItem('token'); // Lấy token từ localStorage
      const response = await axios.post(
        `${process.env.REACT_APP_API_DB_URL}/close-loan-credit/${loanId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}` // Thêm token vào header
          }
        }
      );

      let message = '';
      let type = '';
      if (response.status === 200) {
        message = `Đóng HĐ thành công, mã HĐ: ${loanId}` ;
        type = 'success';
      } else {
        message = 'Đóng HĐ thất bại';
        type = 'error';
      }

      showNotification(message, type);
     // console.log('Response:', response.data);
    } catch (error) {
      console.error('Error saving contract:', error);
    } finally {
      setLoadingItem(false);
    }
  };

  return (
    <div className="p-8">


      <div className="flex flex-col">

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Ngày đóng hợp đồng <span className="text-red-500">*</span>
          </label>
          <div className="flex items-center">
            <DatePicker
              value={closeDate ? dayjs(closeDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
              format={'DD/MM/YYYY'}
              onChange={(date, dateString) => {
                setCloseDate(dateString); // Update fromDate when a new date is picked
              }}
            />
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Tiền cầm
          </label>
          <div className="flex items-center">
            <label>{totalMoney.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Nợ cũ
          </label>
          <div className="flex items-center">
            <label>{debitMoney.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Tiền lãi
          </label>
          <div className="flex items-center">
            <label>{`${totalInterest.toLocaleString('vi-VN')} VNĐ (${dayDiff} ngày)`}</label>
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="amount">
            Tiền khác <span className="text-red-500">*</span>
          </label>
          <div className="flex items-center">
            <input
              type="text"
              className="w-full border border-gray-300 p-2 rounded"
              value={amount}
              onChange={handleInputChange}
            />
          </div>
        </div>


        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Tổng tiền chuộc
          </label>
          <div className="flex items-center">
            <label>{totalMoneyNeedClose.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>


        <div className="mb-4 flex items-start w-full max-w-xs">
          <div className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="amount" />

          <div className="flex flex-col items-center mt-4">
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
              onClick={handleSubmit}
            >
              <FaSave className="mr-2" />
              <span>Đóng HĐ</span>
              {loadingItem && ( // Show Spin only when loading
                <span className="ml-3">
                  <Spin indicator={whiteSpinnerIcon} />
                </span>
              )}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
